import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { NavBar } from './Components/NavBar';
import { Banner } from './Components/Banner';
import { Projects } from './Components/Projects';
import { Contact } from './Components/Contact';
import { Experience } from './Components/Experience';
import { Skills2 } from './Components/Skills2';
import { Footer } from './Components/Footer';

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Experience />
      <Skills2 />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
